import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { I18nProvider } from './i18n';
import { Layout } from './components/Layout';
import { HomePage } from './pages/HomePage';
import { HowItWorksPage } from './pages/HowItWorksPage';
import { FeesPage } from './pages/FeesPage';
import { CoinsPage } from './pages/CoinsPage';
import { AboutPage } from './pages/AboutPage';
import { FaqPage } from './pages/FaqPage';
import { ContactPage } from './pages/ContactPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { TermsPage } from './pages/TermsPage';
import { AmlKycPage } from './pages/AmlKycPage';
import { DocsPage } from './pages/DocsPage';
import { ExchangePairPage } from './pages/ExchangePairPage';
import { NotFoundPage } from './pages/NotFoundPage';

const AdminLayout = lazy(() => import('./admin/AdminLayout').then((m) => ({ default: m.AdminLayout })));
const AdminLoginPage = lazy(() => import('./admin/AdminLoginPage').then((m) => ({ default: m.AdminLoginPage })));
const AdminDashboardPage = lazy(() => import('./admin/AdminDashboardPage').then((m) => ({ default: m.AdminDashboardPage })));
const AdminOrdersPage = lazy(() => import('./admin/AdminOrdersPage').then((m) => ({ default: m.AdminOrdersPage })));
const AdminConfigPage = lazy(() => import('./admin/AdminConfigPage').then((m) => ({ default: m.AdminConfigPage })));

function App() {
  return (
    <I18nProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="how-it-works" element={<HowItWorksPage />} />
            <Route path="fees" element={<FeesPage />} />
            <Route path="coins" element={<CoinsPage />} />
            <Route path="about" element={<AboutPage />} />
            <Route path="faq" element={<FaqPage />} />
            <Route path="contact" element={<ContactPage />} />
            <Route path="privacy" element={<PrivacyPage />} />
            <Route path="terms" element={<TermsPage />} />
            <Route path="aml-kyc-policy" element={<AmlKycPage />} />
            <Route path="docs" element={<DocsPage />} />
            <Route path="exchange/:pair" element={<ExchangePairPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
          <Route path="/admin/login" element={
            <Suspense fallback={<div className="app-loading">Loading…</div>}><AdminLoginPage /></Suspense>
          } />
          <Route path="/admin" element={
            <Suspense fallback={<div className="app-loading">Loading…</div>}><AdminLayout /></Suspense>
          }>
            <Route index element={<AdminDashboardPage />} />
            <Route path="orders" element={<AdminOrdersPage />} />
            <Route path="config" element={<AdminConfigPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </I18nProvider>
  );
}

export default App;
